<form (ngSubmit)="applyTempChanges()">

	<device-group [target]="target" [network]="network"></device-group>

	<button type="submit" pButton style="margin-top: 5px;" [disabled]="!enableApply"
			label="Apply"></button>

</form>
